import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import middleware from '../middleware'
import reducer from './rootReducer'

// const store = createStore(reducer, {}, applyMiddleware(...middlewares))
export const store = createStore(reducer, {}, composeWithDevTools(
    applyMiddleware(...middleware)
))

export default ({ children }) => {
    return (
        <Provider store={store}>
            {children}
        </Provider>
    )
}


// WEBPACK FOOTER //
// ./src/store/index.js